import { useState } from "react";
import Button from "@/components/base/Button";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/site";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-28 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <SectionHeading
              eyebrow="Frequently Asked Questions"
              title="Answers to common patient questions"
              align="left"
              description="If your question is not answered here, our team is happy to help — just give us a call."
            />
            <div className="mt-7">
              <Button to="/appointment" size="md" icon="ri-calendar-check-line">
                Book Appointment
              </Button>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="reveal divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-100/50">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={faq.q}>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                      aria-expanded={isOpen}
                    >
                      <span className="font-heading text-base font-semibold text-foreground-950">{faq.q}</span>
                      <span
                        className={`flex h-7 w-7 flex-none items-center justify-center rounded-full transition-colors ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true"></i>
                      </span>
                    </button>
                    {isOpen ? (
                      <div className="px-5 pb-5">
                        <p className="font-body text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}